import { createApiRequest } from '@/api/request'
import apiConfig from './configs'

const api: any = {}
Object.entries(apiConfig).forEach(([k, v]) => {
    api[k] = createApiRequest(v)
})

export default api
